import { withReferrerPolicy } from "../../utils/backend/with-referrer-policy";
import { withSanitization } from "../../utils/backend/with-sanitization";
import { FeatureButton } from "../feature-buttons";
import { ChatbotAlert } from "./alert";

import { pageConfigBuergergeld } from "./page-config-ids/bgeld";
import { pageConfigKurzarbeitergeld } from "./page-config-ids/kurzarbeitergeld";
import { pageConfigArbeitslosengeld } from "./page-config-ids/arbeitslosengeld";
import { pageConfigFamka } from "./page-config-ids/famka";
import { pageConfigStartseite } from "./page-config-ids/startseite";
import { pageConfigDZT } from "./page-config-ids/dzt";
import { pageConfigSAS } from "./page-config-ids/sas";
import { pageConfigWAU } from "./page-config-ids/wau";
import { pageConfigPINK } from "./page-config-ids/pink";
import { pageConfigFormDE, pageConfigFormUA, pageConfigFormularDE, pageConfigFormularUA } from './page-config-ids/form'
import { pageConfigInkasso } from "./page-config-ids/inkasso";

export interface PageConfig {
    header: string;
    welcome: {
        text: string;
        info?: string
        disclaimer: string;
        additionalContent?: WelcomeAdditionalContent;
        buttons: FeatureButton[];
    };
    floatingButton?: {},
    alert: ChatbotAlert;
    whitelist?: string[];
}

export interface PageConfigs {
    [pageId: string]: PageConfig;
}

export interface WelcomeAdditionalContent {
    firstText: string;
    buttons: FeatureButton[];
    secondText: string;
}

export const pageConfigs: PageConfigs = withReferrerPolicy(
    withSanitization({
        // BGELD
        bgeld: pageConfigBuergergeld,
        "einfuehrung-buergergeld": pageConfigBuergergeld,
        "arbeitslos-arbeit-finden/buergergeld": pageConfigBuergergeld,
        "arbeitslos-arbeit-finden/buergergeld/buergergeld-beantragen":
            pageConfigBuergergeld,
        "arbeitslos-arbeit-finden/buergergeld/finanziell-absichern/antrag-bescheid":
            pageConfigBuergergeld,
        "arbeitslos-arbeit-finden/buergergeld/pflichten-verstehen-und-beachten/aenderungen-nachweise":
            pageConfigBuergergeld,
        "arbeitslos-arbeit-finden/buergergeld/finanziell-absichern/auszahlung-dauer":
            pageConfigBuergergeld,
        "arbeitslos-arbeit-finden/buergergeld/weiterbewilligungsantrag-buergergeld":
            pageConfigBuergergeld,
        "arbeitslos-arbeit-finden/buergergeld/finanziell-absichern":
            pageConfigBuergergeld,
        "arbeitslos-arbeit-finden/buergergeld/finanziell-absichern/uebergang-buergergeld":
            pageConfigBuergergeld,
        "arbeitslos-arbeit-finden/buergergeld/pflichten-verstehen-und-beachten":
            pageConfigBuergergeld,
        "arbeitslos-arbeit-finden/buergergeld/termin-jobcenter":
            pageConfigBuergergeld,
        "arbeitslos-arbeit-finden/buergergeld/finanziell-absichern/voraussetzungen-einkommen-vermoegen":
            pageConfigBuergergeld,
        "arbeitslos-arbeit-finden/buergergeld/arbeit-finden":
            pageConfigBuergergeld,
        "arbeitslos-arbeit-finden/buergergeld/kooperationsplan":
            pageConfigBuergergeld,
        "arbeitslos-arbeit-finden/buergergeld/pflichten-verstehen-und-beachten/eingliederungsvereinbarung":
            pageConfigBuergergeld,
        "arbeitslos-arbeit-finden/buergergeld/finanziell-absichern/zusammensetzung-bedarfe":
            pageConfigBuergergeld,
        "arbeitslos-arbeit-finden/buergergeld/wohnen": pageConfigBuergergeld,
        "arbeitslos-arbeit-finden/buergergeld/finanziell-absichern/gesundheit-versicherung":
            pageConfigBuergergeld,
        // KUG
        "arbeitslos-arbeit-finden/arbeitslosengeld/finanzielle-hilfen/kurzarbeitergeld-arbeitnehmer":
            pageConfigKurzarbeitergeld,
        "finanzielle-hilfen/kurzarbeitergeld-arbeitnehmer":
            pageConfigKurzarbeitergeld,
        "kug-rechner": pageConfigKurzarbeitergeld,

        // ALG
        "alg-bot": pageConfigArbeitslosengeld,
        "arbeitslos-arbeit-finden/arbeitslosengeld": pageConfigArbeitslosengeld,
        "arbeitslos-arbeit-finden/arbeitslosengeld/arbeitslosengeld-reicht-nicht":
            pageConfigArbeitslosengeld,
        "arbeitslos-arbeit-finden/arbeitslos-melden-arbeitslosengeld-beantragen":
            pageConfigArbeitslosengeld,
        "arbeitslos-arbeit-finden/arbeitslosengeld/finanzielle-hilfen":
            pageConfigArbeitslosengeld,
        "das-muessen-sie-beachten/krankheit-pflege-betreuung":
            pageConfigArbeitslosengeld,
        "das-muessen-sie-beachten/kuendigung-abfindung-freistellung":
            pageConfigArbeitslosengeld,
        "das-muessen-sie-beachten/nebenjob-und-arbeitslosengeld":
            pageConfigArbeitslosengeld,
        "das-muessen-sie-beachten/urlaub-und-umzug": pageConfigArbeitslosengeld,
        "das-muessen-sie-beachten/veraenderungsmitteilung-arbeitslosengeld":
            pageConfigArbeitslosengeld,
        "arbeitslos-arbeit-finden/finanzielle-hilfen/arbeitslosengeld-anspruch-hoehe-dauer":
            pageConfigArbeitslosengeld,
        "arbeitslos-arbeit-finden/finanzielle-hilfen/einkommen-vermoegen-arbeitslosengeld":
            pageConfigArbeitslosengeld,
        "arbeitslos-arbeit-finden/arbeitslosengeld/existenzgruendung-gruendungszuschuss":
            pageConfigArbeitslosengeld,
        "kontakt/de/arbeitslos-und-arbeit-finden": pageConfigArbeitslosengeld,
        "alg-antrag": pageConfigArbeitslosengeld,
        // NEU ALG
        "arbeitslos-arbeit-finden/arbeitslosengeld/das-muessen-sie-beachten/arbeitslosengeld-bescheid": pageConfigArbeitslosengeld,
        "arbeitslos-arbeit-finden/arbeitslosengeld/wege-zum-neuen-job": pageConfigArbeitslosengeld,
        "arbeitslos-arbeit-finden/arbeitslosengeld/finanzielle-hilfen/foerderung-aus-dem-vermittlungsbudget": pageConfigArbeitslosengeld,
        "arbeitslos-arbeit-finden/arbeitslosengeld/beratung-termin": pageConfigArbeitslosengeld,
        "arbeitslos-arbeit-finden/arbeitslosengeld/finanzielle-hilfen/insolvenzgeld-arbeitnehmer": pageConfigArbeitslosengeld,
        "unternehmen/finanziell/insolvenzgeld-arbeitgeber": pageConfigArbeitslosengeld,
        "arbeitslos-arbeit-finden/arbeitslosengeld/finanzielle-hilfen/video-insolvenzgeld-beantragen": pageConfigArbeitslosengeld,
        "freiwillige-arbeitslosenversicherung": pageConfigArbeitslosengeld,
        // FAMKA
        "famka-bot": pageConfigFamka,
        "familie-und-kinder": pageConfigFamka,
        "familie-und-kinder/kinderzuschlag-anspruch-hoehe-dauer":
            pageConfigFamka,
        "familie-und-kinder/kinderzuschlag-verstehen": pageConfigFamka,
        "familie-und-kinder/kiz-lotse": pageConfigFamka,
        "familie-und-kinder/videoberatung": pageConfigFamka,
        "kiz/ui/start": pageConfigFamka,
        "kontakt/de/familie-und-kinder": pageConfigFamka,
        "opal/kgo-veraenderung-ui": pageConfigFamka,
        "familie-und-kinder/kindergeld-nach-schulabschluss": pageConfigFamka,
        "familie-und-kinder/kindergeld-nach-ausbildung": pageConfigFamka,
        "opal/kgo-antraggeburt-ui": pageConfigFamka,
        "opal/kgo-antragab18-ui": pageConfigFamka,
        "opal/kgo-nup-ui": pageConfigFamka,
        "familie-und-kinder/infos-rund-um-kindergeld": pageConfigFamka,
        "familie-und-kinder/kindergeld-anspruch-hoehe-dauer": pageConfigFamka,
        "familie-und-kinder/kindergeld-ab-18-jahren": pageConfigFamka,
        "familie-und-kinder/nachweise-einreichen": pageConfigFamka,
        "familie-und-kinder/veraenderungen-mitteilen": pageConfigFamka,
        "familie-und-kinder/auszahlungstermine": pageConfigFamka,
        "familie-und-kinder/kindergeld-ausland": pageConfigFamka,
        "familie-und-kinder/kindergeld-fuer-kinder-mit-behinderung":
            pageConfigFamka,
        "familie-und-kinder/kindergeld-auszahlung-andere-personen":
            pageConfigFamka,
        "familie-und-kinder/kinderfreizeitbonus": pageConfigFamka,
        startseite: pageConfigStartseite,
        "vor-ort": pageConfigDZT,
        // SAS
        sas: pageConfigSAS,
        wau: pageConfigWAU,
        bildung: pageConfigSAS,
        "bildung/ausbildung": pageConfigSAS,
        "bildung/studium": pageConfigSAS,
        "bildung/zwischenzeit": pageConfigSAS,
        // FORM
        'form': pageConfigFormDE,
        'form/form-assistant-de': pageConfigFormDE,
        'form/form-assistant-ua': pageConfigFormUA,
        'form/form-de': pageConfigFormularDE,
        'form/form-ua': pageConfigFormularUA,
        "form/inkasso": pageConfigInkasso,
        // PINK
        pink: pageConfigPINK,
        unternehmen: pageConfigPINK,
    })
);
